import React, { useEffect, useState } from "react";
import { Stack, Button, Fade, Box, IconButton, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import styles from "../pages/Styles/Congratulation.module.scss";
import { stageDetailsAPICall } from "../shared/APICalls";
import PDFViewerIframe from "../Components/PDFIframe/PDFWithIframe";
import CloseIcon from "@mui/icons-material/Close";
import esignImage from "../Components/assets/Images/EsignImage.jpg";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  padding: "0px 0px 0px 5px",
};

export default function CongratulationsPage() {
  const navigate = useNavigate();

  const [showModal, setshowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [open, setOpen] = React.useState(true);
  const [clientCode, setClientCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [ccode, setccode] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    // checkUserLoggedIn(navigate);

    let objNew: any = {
      stage: "congratulations",
    };

    stageDetailsAPICall(objNew)
      .then((response: any) => {
        const responseData = response?.data;
        // console.log("responseData", responseData.data);

        if (responseData?.data?.data?.application_no) {
          setClientCode(responseData?.data?.data?.application_no);
          setccode(responseData?.data?.data?.client_code);
        }

        if (responseData?.data?.data?.url) {
          setPdfUrl(responseData?.data?.data?.url);
        }
      })
      .catch((error: any) => {});
  }, []);

  const handlePreviewClick = () => {
    setshowModal(true);
  };

  const handlePreviewClose = () => {
    setshowModal(false);
  };

  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>Congrats!</p>
            <p className={styles.signup}>
              Application Process is Submitted for Approval!
            </p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                Your application
                <span style={{ fontWeight: 700, margin: "0px 5px" }}>
                  #{clientCode}
                </span>{" "}
                is under review and may take up to 24 hours. You will receive an
                email with your credentials once processed.
              </p>
            </div>
            <Button
              type="submit"
              variant="contained"
              sx={{
                width: "200px",
                height: "50px",
              }}
              className={styles.previewButton}
              id="aadharOpenLinkButton"
              onClick={handlePreviewClick}
            >
              View Esign Document
            </Button>
          </div>
        </div>

        <div className={styles.referal}>Invite friends</div>
        <div className={styles.generated}>
          https://signup.firstock.in/?c={ccode}
          <CopyToClipboard
            text={`https://signup.firstock.in/?c=${ccode}`}
            onCopy={() => {
              setCopied(true);
              setTimeout(() => {
                setCopied(false);
              }, 3000);
            }}
          >
            <div style={{ cursor: "pointer" }}>
              {copied ? (
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.4725 9.30126C20.2857 9.11401 20.032 9.00878 19.7675 9.00878C19.503 9.00878 19.2493 9.11401 19.0625 9.30126L13.4225 14.9413L14.8325 16.3513L20.4725 10.7013C20.8525 10.3213 20.8525 9.68126 20.4725 9.30126ZM24.7125 9.29126L14.8325 19.1713L11.3525 15.7013C11.1657 15.514 10.912 15.4088 10.6475 15.4088C10.383 15.4088 10.1293 15.514 9.9425 15.7013C9.5525 16.0913 9.5525 16.7213 9.9425 17.1113L14.1225 21.2913C14.5125 21.6813 15.1425 21.6813 15.5325 21.2913L26.1225 10.7113C26.5125 10.3213 26.5125 9.69126 26.1225 9.30126H26.1125C25.7325 8.90126 25.1025 8.90126 24.7125 9.29126ZM4.2925 17.1213L8.4725 21.3013C8.8625 21.6913 9.4925 21.6913 9.8825 21.3013L10.5825 20.6013L5.7025 15.7013C5.51567 15.514 5.26202 15.4088 4.9975 15.4088C4.73298 15.4088 4.47933 15.514 4.2925 15.7013C3.9025 16.0913 3.9025 16.7313 4.2925 17.1213Z"
                    fill="#049981"
                  />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_13056_173691)">
                    <path
                      d="M7.5 15C7.0875 15 6.73438 14.8531 6.44062 14.5594C6.14687 14.2656 6 13.9125 6 13.5V3.5C6 3.0875 6.14687 2.73438 6.44062 2.44063C6.73438 2.14688 7.0875 2 7.5 2H15.5C15.9125 2 16.2656 2.14688 16.5594 2.44063C16.8531 2.73438 17 3.0875 17 3.5V13.5C17 13.9125 16.8531 14.2656 16.5594 14.5594C16.2656 14.8531 15.9125 15 15.5 15H7.5ZM7.5 13.5H15.5V3.5H7.5V13.5ZM4.5 18C4.0875 18 3.73437 17.8531 3.44062 17.5594C3.14687 17.2656 3 16.9125 3 16.5V5.75C3 5.5375 3.07146 5.35937 3.21437 5.21562C3.35729 5.07187 3.53437 5 3.74562 5C3.95687 5 4.13542 5.07187 4.28125 5.21562C4.42708 5.35937 4.5 5.5375 4.5 5.75V16.5H13.25C13.4625 16.5 13.6406 16.5715 13.7844 16.7144C13.9281 16.8573 14 17.0344 14 17.2456C14 17.4569 13.9281 17.6354 13.7844 17.7812C13.6406 17.9271 13.4625 18 13.25 18H4.5Z"
                      fill="#6B7280"
                    />
                  </g>
                </svg>
              )}
            </div>
          </CopyToClipboard>
        </div>


      </div>

      {showModal && (
        <Stack>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                {/* <PdfModal
                // url={"https://arxiv.org/pdf/quant-ph/0410100.pdf"}
                url={documentURL}
              /> */}
                <Stack
                  alignItems={"flex-end"}
                  marginRight={"10px"}
                  marginTop={"5px"}
                >
                  <IconButton onClick={handlePreviewClose}>
                    <CloseIcon />
                  </IconButton>
                </Stack>
                <div className={styles.pdfMobilePreview}>
                  <img
                    src={esignImage}
                    style={{
                      width: "95%",
                      height: "100%",
                      objectFit: "inherit",
                      filter: "brightness(80%)",
                      marginBottom: "20px",
                    }}
                  />

                  <a
                    href={pdfUrl}
                    download="Esign-PDF-document"
                    target="_blank"
                    rel="noreferrer"
                    className={styles.previewdownlaodesign}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        background: "#1976d2",
                        "&:hover": { background: "#1976d2" },
                      }}
                    >
                      View Esign Document
                    </Button>
                  </a>
                </div>
                <div className={styles.pdfDesktopPreview}>
                  <PDFViewerIframe urldata={pdfUrl} />
                </div>
              </Box>
            </Fade>
          </Modal>
        </Stack>
      )}
    </div>
  );
}
